import {UNITS_SAME_TIME_COUNT_LIMIT} from "../../configs/units";
import {getBotLeagueArmyCap} from "../../configs/botArmyCap";
import {getRecruitableUnitTypeIds} from "../unit/getRecruitableUnitTypeIds";
import {getSameTypeUnitLimit} from "../gameState/recruitment/checkSameTypeUnitRecruitmentLimit";
import {isPreW38HireCapPlayer} from "./abTestGates";

/**
 * Волна 38: общий потолок армии бота по его лиге (configs/botArmyCap) — в найме
 * (подчасть C, A/B-гейт isPreW38HireCapPlayer; legacy держит прежний потолок
 * UNITS_SAME_TIME_COUNT_LIMIT). План стройки (цели ферм и казарм, резервы монет на
 * найм) остается под прежний потолок 4: подчасть P «план под потолок лиги» в A/B
 * отчета 36 вместе с C стоила ботам 5.7 очка и удалена
 */

// Сколько отрядов вообще пустят правила: сумма лимитов «одного типа» по типам,
// доступным игроку (у великанов один d20 — 4, у остальных фракций не меньше 16)
const calcTypeLimitsCapacity = (player) => getRecruitableUnitTypeIds(player)
  .reduce((sum, unitTypeId) => sum + getSameTypeUnitLimit(player, unitTypeId), 0);

// Потолок лиги, но не выше емкости правил по типам и не ниже прежних 4: иначе бот
// держал бы «свободные слоты» под отряды, которых ему не нанять
const getRulesBoundLeagueArmyCap = (player) => {
  const cap = getBotLeagueArmyCap(player);
  return cap > UNITS_SAME_TIME_COUNT_LIMIT
    ? Math.max(UNITS_SAME_TIME_COUNT_LIMIT, Math.min(cap, calcTypeLimitsCapacity(player)))
    : cap;
};

// C: потолок армии при найме (сверх него — только точечные слоты фракций и T/F)
export const getBotHireArmyCap = (player) => (
  !player || isPreW38HireCapPlayer(player.id) ? UNITS_SAME_TIME_COUNT_LIMIT : getRulesBoundLeagueArmyCap(player)
);
